import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArkUnitOfWork } from 'app/core/core.module';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { Person } from 'app/core/model/entity-model';
import { Router } from '@angular/router';
import _ from 'lodash';

@Component({
    selector: 'app-surveys',
    templateUrl: './surveys.component.html',
    styleUrls: ['./surveys.component.scss'],
    providers: [ArkUnitOfWork],
    imports: [CommonModule, DevExtremeModule]
})
export class SurveysComponent implements OnInit {
    people: any[];
    selectedPerson: Person;
    personInterests: any;

    @ViewChild('peopleGrid') peopleGrid: DxDataGridComponent;

    constructor(private uow: ArkUnitOfWork, private router: Router) {}

    async ngOnInit() {
        const interest = this.uow.interests.all('interestCategory.displayOrder,displayOrder', 'interestCategory');
        const query = this.uow.people
            .baseQuery()
            .where('includeInDirectory', '==', true)
            .select(['firstName', 'lastName', 'id']);
        this.people = (await this.uow.executeQuery(query)) as any[];
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons'
        });
    }

    async focusedRowChanged() {
        this.selectedPerson = await this.uow.people.byId(this.peopleGrid.focusedRowKey, 'personInterests, family');
        this.personInterests = _(this.selectedPerson.personInterests)
            .sortBy(['interest.interestCategory.displayOrder', 'interest.displayOrder'])
            .value();
    }

    edit() {
        this.router.navigate(['/interests/surveys/' + this.selectedPerson.id]);
    }
}
